import { initVideoPlay } from "@js/video-play.js";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".flex-layout.content_media_narrow-layout").forEach((layout) => {
        initVideoPlay(layout.querySelector("video"), layout.querySelector(".video-play"));
    });
});
